import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Which view is active: list (default), form (create/edit), or project view (studio)
  showProjectForm: false,
  editingProject: null,
  projectDetails: null,     // project details for studio/project view

  activeStudioView: 'ABSTRACT_LIST',
  filtersCollapsed: false,
};

const screeningSpaceSlice = createSlice({
  name: 'screeningSpace',
  initialState,
  reducers: {
    setShowProjectForm(state, action) {
      state.showProjectForm = action.payload;
    },

    setEditingProject(state, action) {
      state.editingProject = action.payload;
    },

    setProjectDetails(state, action) {
      state.projectDetails = action.payload;
    },

    setActiveStudioView(state, action) {
      state.activeStudioView = action.payload;
    },

    // Go back to list view — reset all view states
    resetToListView(state) {
      state.showProjectForm = false;
      state.editingProject = null;
      state.projectDetails = null;
      state.activeStudioView = 'ABSTRACT_LIST';
      state.filtersCollapsed = false;
    },

    // Open form for creating new project
    openCreateForm(state) {
      state.projectDetails = null;
      state.editingProject = null;
      state.showProjectForm = true;
      state.activeStudioView = 'ABSTRACT_LIST';
    },

    // Open form for editing existing project
    openEditForm(state, action) {
      state.projectDetails = null;
      state.editingProject = action.payload;
      state.showProjectForm = true;
      state.activeStudioView = 'ABSTRACT_LIST';
    },

    // Open project view (studio)
    openProjectView(state, action) {
      state.projectDetails = action.payload;
      state.showProjectForm = false;
      state.editingProject = null;
    },

    setFiltersCollapsed(state, action) {
      state.filtersCollapsed = action.payload;
    },

    resetScreeningSpaceState() {
      return initialState;
    },
  },
});

export const {
  setShowProjectForm,
  setEditingProject,
  setProjectDetails,
  setActiveStudioView,
  setFiltersCollapsed,
  resetToListView,
  openCreateForm,
  openEditForm,
  openProjectView,
  resetScreeningSpaceState,
} = screeningSpaceSlice.actions;

export default screeningSpaceSlice.reducer;